import { forwardRef } from "react";

type CoreFileInputProps = {
	accept: string;
	onChange: (files: File[]) => void;
	multiple?: boolean;
};

const CoreFileInput = forwardRef<HTMLInputElement, CoreFileInputProps>(function CoreFileInput(
	{ accept, onChange, multiple },
	ref,
) {
	const handleFileChange = (fileList: FileList | null) => {
		if (!fileList) return;
		let files = Array.from(fileList);

		// If multiple is false, we only care about the first file
		if (!multiple && files.length > 0) {
			files = [files[0]];
		}

		if (files.length > 0) {
			onChange(files);
		}
	};

	return (
		<input
			hidden
			ref={ref}
			accept={accept}
			type="file"
			onChange={(e) => {
				handleFileChange(e.target.files);
				e.currentTarget.value = ""; // Clear the input so the same file can be uploaded again if needed
			}}
			multiple={multiple}
		/>
	);
});

export default CoreFileInput;
